"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _moment = _interopRequireDefault(require("moment"));

var _dateFormat = require("./constants/dateFormat");

function isMsDate(date) {
  return !Number.isNaN(parseFloat(date)) && Number.isFinite(date);
}

function getMsDate(date) {
  if (typeof date === 'string') {
    return parseInt(date, 10);
  }

  return date;
}

function getMoment(date) {
  var newDate = date;

  if (isMsDate(date)) {
    newDate = getMsDate(date);
  }

  return (0, _moment["default"])(newDate, ['x', _dateFormat.DATE_FORMAT.ISO_STRING, _dateFormat.DATE_FORMAT.ISO_DATE]);
}

module.exports = getMoment;